import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Register service worker for PWA/share target
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
